import { render, staticRenderFns } from "./makeWish.vue?vue&type=template&id=a9de7dfa&scoped=true"
import script from "./makeWish.vue?vue&type=script&lang=ts"
export * from "./makeWish.vue?vue&type=script&lang=ts"
import style0 from "./makeWish.vue?vue&type=style&index=0&id=a9de7dfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9de7dfa",
  null
  
)

export default component.exports